import { InputMaybe, UpdateDraftProjectMutationVariables } from '../../../../generated/graphql';
import { EditingProjectState } from '../../../types/EditingProjectState';
import { InputtedCreationSet } from '../../../types/InputtedCreationSet';

const recastTitle = (title: string) => {
  return title.trim() === '' ? 'Untitled Project' : title;
};

const recastCreationSets = (inputtedCreationSet: InputtedCreationSet | null) => {
  if (inputtedCreationSet === null) {
    return null;
  }
  return {
    id: inputtedCreationSet.id,
    creativeFormats: inputtedCreationSet.creativeFormats.map((format) => {
      return {
        resizeBaseIndex: format.resizeBaseId
          ? inputtedCreationSet.creativeFormats.indexOf(
              inputtedCreationSet.creativeFormats.find(
                (creativeFormat) => (creativeFormat.id || creativeFormat.tmpid) === format.resizeBaseId,
              )!,
            )
          : null,
        networkId: format.network.id,
        placementId: format.placement.id,
        creativeTypeId: format.creativeType.id,
        attribute: {
          aspectRatio: format.attribute.aspectRatio
            ? {
                supportingAspectRatioId: format.attribute.aspectRatio.supportingAspectRatioId,
                requiredOption: format.attribute.aspectRatio.requiredOption,
                aspectRatio: format.attribute.aspectRatio.aspectRatio,
                size: format.attribute.aspectRatio.size,
              }
            : undefined,
          playbackTime: format.attribute.playbackTime
            ? {
                supportingPlaybackTimeId: format.attribute.playbackTime.supportingPlaybackTimeId,
                requiredOption: format.attribute.playbackTime.requiredOption,
                seconds: format.attribute.playbackTime.seconds,
              }
            : undefined,
        },
      };
    }),
    amount: inputtedCreationSet.amount,
    deliveryDueDays: inputtedCreationSet.deliveryDueDays,
  };
};

// RecoilやRepatch内のステートにある、編集中のプロジェクトのデータをAPIに返せる形に変換する
// projectPropertyConverter(APIからもらったデータをローカルで使えるように変換するfunction群)の逆。
export const projectPropertyRecaster = (state: EditingProjectState) => ({
  title: () => recastTitle(state.title),
  creationSet: () => recastCreationSets(state.creationSet),
});

export const stateToUpdateProjectVars = ({
  state,
  projectId,
  options,
}: {
  state: EditingProjectState;
  projectId: string;
  options?: InputMaybe<string | Array<string>>;
}): UpdateDraftProjectMutationVariables => {
  const recaster = projectPropertyRecaster(state);
  return {
    ...state,
    id: projectId,
    title: recaster.title(),
    creationSet: recaster.creationSet(),
    creativeBriefValues: { fields: state.creativeBriefValue?.values },
    assetCategoryValues: { fields: state.assetCategoryValue?.values },
    selectedPricingMerchandiseOptionIds: options,
  };
};
